/** Stabile ID-Erzeugung mit Rueckfallebene fuer Umgebungen ohne `randomUUID`. */
export function newId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
